import React, { Fragment } from "react";
const Index = ({ children }) => {
  return <Fragment>{children}</Fragment>;
};

export default Index;
